import baseTemplates from '@components/Widgets/Templates/Base/all_unique'
import themesTemplates
  from '@components/Widgets/Templates/Themes/allThemeTemplates'
import themes from '@components/Widgets/Templates/Themes/all'

export default {
  namespaced: true,
  state: () => ({
    themes,
    baseTemplates,       // Now an object with template names as keys
    themesTemplates,     // Object containing all theme templates, keyed by theme name
    selectedTheme: 'DEFAULT', // 'DEFAULT' represents the base theme
  }),
  getters: {
    selectedTheme(state) {
      return state.selectedTheme
    },
    getWidgetTemplateByID: (state, getters) => (templateID) => {
      const allTemplates = getters.allTemplatesForSelectedTheme
      const templates = Object.values(allTemplates)
      const foundTemplate = templates.find((obj) => {
        return obj.info.templateID === templateID
      })

      if (!foundTemplate) {
        console.warn(`Template with ID ${templateID} not found.`)
        return null
      }

      return foundTemplate.json
    },
    getDefaultWidgetTemplateByType: (state) => (type) => {
      const templates = Object.values(state.defaultWidgetTemplates)
      return templates.find((obj) => obj.type === type)
    },
    sortedTemplatesForSelectedTheme(state, getters) {
      const allTemplates = getters.allTemplatesForSelectedTheme
      const templatesArray = Object.values(allTemplates)

      templatesArray.sort((a, b) => {
        const priorityA = a.info.priority !== undefined
          ? a.info.priority
          : Infinity
        const priorityB = b.info.priority !== undefined
          ? b.info.priority
          : Infinity
        return priorityA - priorityB
      })

      return templatesArray
    },
    allTemplatesForSelectedTheme(state) {
      if (state.selectedTheme === 'DEFAULT') {
        // Return all base templates
        return state.baseTemplates
      }

      // Get the theme templates for the specified theme
      const themeTemplates = state.themesTemplates[state.selectedTheme]

      if (!themeTemplates) {
        // If the theme does not exist, return base templates or handle the error as needed
        return state.baseTemplates
      }

      // Combine base templates with theme templates
      const allTemplates = {}

      // Include all templates, overriding base templates with theme templates where applicable
      for (const templateName in state.baseTemplates) {
        if (themeTemplates[templateName]) {
          // Use the theme-specific template
          allTemplates[templateName] = themeTemplates[templateName]
        } else {
          // Use the base template
          allTemplates[templateName] = state.baseTemplates[templateName]
        }
      }

      // Add any templates that exist only in the theme
      for (const templateName in themeTemplates) {
        if (!state.baseTemplates[templateName]) {
          allTemplates[templateName] = themeTemplates[templateName]
        }
      }

      return allTemplates
    },
  },
  mutations: {
    SET_SELECTED_THEME(state, themeName) {
      state.selectedTheme = themeName
    },
  },
  actions: {
    setSelectedTheme({ commit }, themeName) {
      commit('SET_SELECTED_THEME', themeName)
    },
  },
}
